module.exports = __webpack_public_path__ + "static/media/gb-nir.5365b02e.webp";